import styles from './styles.module.scss';

export const MainImageContainer = () => {
    return <section className={styles.imageWrapper} />;
};
